import { OnHydrationEndAsync, PageContext } from 'vike/types';
import { tiptapEmbedsPlugin } from '../../util/tiptapEmbedsPlugin';

export const onHydrationEnd: OnHydrationEndAsync = async (
  pageContext: PageContext,
): ReturnType<OnHydrationEndAsync> => {
  const { app } = pageContext;

  if (!app) {
    return;
  }

  app.use(tiptapEmbedsPlugin);
};
